import React from "react";

import { useBrandStyleClasses } from "./BrandContext.js";

export const ContentBox = ({
  children,
  className,
  simple,
  playful,
  elegant,
  brutalist,
}) => {
  const brandStyleClasses = useBrandStyleClasses();
  return (
    <div
      className={brandStyleClasses(
        `${className} bg-white container flex-col space-y-8`,
        {
          simple: simple || "p-24 rounded shadow border border-neutral-200",
          playful: playful || "p-24 rounded-lg shadow",
          elegant: elegant || "font-light",
          brutalist:
            brutalist || "p-24 shadow-brutalist border-2 border-venue-brand",
        }
      )}
    >
      {children}
    </div>
  );
};

export const Button = ({ tag, children, primary, secondary, ...props }) => {
  const Tag = tag || "button";
  const brandStyleClasses = useBrandStyleClasses();

  const secondaryStyles = {
    simple: "rounded border-2 border-venue-brand text-venue-brand",
    playful:
      "rounded-lg shadow bg-white border-2 border-venue-brand text-venue-brand",
    elegant: "",
    brutalist: "border-2 border-venue-brand bg-white text-venue-brand",
  };

  const primaryStyles = {
    simple: "rounded shadow text-venue-brand-contrast bg-venue-brand ",
    playful: "rounded-lg shadow text-venue-brand-contrast bg-venue-brand ",
    elegant: "border border-neutral-800 venue-brand ",
    brutalist:
      "bg-white shadow-brutalist-white bg-venue-brand text-venue-brand-contrast ",
  };

  const styles = secondary ? secondaryStyles : primaryStyles;
  return (
    <Tag
      className={brandStyleClasses(
        "flex-1 flex justify-center items-center p-8 cursor-pointer",
        styles
      )}
      {...props}
    >
      {children}
    </Tag>
  );
};

export const Title = ({ children, simple, playful, elegant, brutalist }) => {
  const brandStyleClasses = useBrandStyleClasses();
  return (
    <h3
      className={brandStyleClasses("", {
        simple: simple || "",
        playful: playful || "text-venue-brand text-lg font-semibold ",
        elegant: elegant || "text-xs uppercase font-light",
        brutalist: brutalist || "uppercase font-semibold",
      })}
    >
      {children}
    </h3>
  );
};
